import { Route } from 'react-router-dom';
import { RequireAdmin } from '../../../common/SharedComponents';

import SubmittedAppsLanding from '../../../applications/submitted/SubmittedAppsLanding';
import AppraiseAppsLanding from '../../../applications/appraise/AppraiseAppsLanding';
import DeclinedAppsLanding from '../../../applications/declined/DeclinedAppsLanding';
import IncompleteAppsLanding from '../../../applications/incomplete/IncompleteAppsLanding';
import ApplicationLanding from '../../../applications/ApplicationLanding';

export default function ApplicationsRoutes() {
    return (
        <>
            <Route
                path='/applications/submitted'
                element={
                    <RequireAdmin>
                        <SubmittedAppsLanding />
                    </RequireAdmin>
                }
            />
            <Route
                path='/applications/appraise'
                element={
                    <RequireAdmin>
                        <AppraiseAppsLanding />
                    </RequireAdmin>
                }
            />
            <Route
                path='/applications/recyclebin'
                element={
                    <RequireAdmin>
                        <DeclinedAppsLanding />
                    </RequireAdmin>
                }
            />
            <Route
                path='/applications/incomplete'
                element={
                    <RequireAdmin>
                        <IncompleteAppsLanding />
                    </RequireAdmin>
                }
            />
            <Route
                path='/applications'
                element={
                    <RequireAdmin>
                        <ApplicationLanding />
                    </RequireAdmin>
                }
            />
        </>
    );
}
